export default __webpack_public_path__ + "static/media/prpage.78081d4d.png";